import qs from 'qs'

const fields = [
  'title',
  'slug',
  'locale',
]

const sort = ['sortKey:asc']

const populate = {
  ...queryFragmentSeo,
  ...queryFragmentBlocks,
  ...queryFragmentEventEntries,
  ...queryFragmentExhibitionEntries,
  ...queryFragmentJournalEntries,
  coverImage: '*',
}

export const queryEducationEntriesThumbnail = (options: QueryManyOptionsi18n) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 100
      },
      sort: sort,
      fields: fields,
      populate: {
        localizations: {
          populate: populate
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `education-entries?${query}`
}
